/**
 * 産廃回収
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/manifests`
const orders_accepts_manifest = {
  namespaced: true,
  actions: {
    /**
     * 追加項目の初期値を取得
     * @return {Promise<unknown>}
     */
    new ({ commit }) {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  }
}
export default orders_accepts_manifest
